<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:3.93194in;height:4.06491in"/></p>
<p style="text-indent:0px;"><em>Thirteen Months of Sunshine</em> is a book based on the detailed diaries I kept while placed in northern Ethiopia by the Voluntary Service Overseas. My time there covered a year spanning 2012 and 2013. The Education Department where I was based really appreciates the support given by VSO. Ethiopians realise that in order to progress as a nation they need to educate their population, and developing a modern, national education system is a massive undertaking. Although VSO does an amazing job preparing volunteers for such work, in reality, I left England knowing very little about Ethiopia, so this is a record of much of my year of my learning and if I am honest, my survival!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?32a46222